module.exports = __webpack_public_path__ + "img/1c47652baf1daf231b70d60d73138aac.5716f1df.png";